import { ContractTemplate } from './Types/contractTemplatesTypes';

export const contractTemplateInitialValues: ContractTemplate = {
  id: 0,
  name: '',
  contentHtml: '',
  logoUrl: '',
};
